// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PlaySquareTwoToneSvg from "@ant-design/icons-svg/es/asn/PlaySquareTwoTone";
import AntdIcon from '../components/AntdIcon';

var PlaySquareTwoTone = function PlaySquareTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PlaySquareTwoToneSvg
  }));
};

PlaySquareTwoTone.displayName = 'PlaySquareTwoTone';
export default React.forwardRef(PlaySquareTwoTone);